import { useMutation } from "@tanstack/react-query";
import { updateSevenRoomsCredentials } from "../../api/bSevenroomsApi";

export const useUpdateSevenRooms = () => {
  return useMutation({
    mutationKey: ["update-sevenrooms"],
    mutationFn: (data) => updateSevenRoomsCredentials(data),
    onError: (error) => {
      console.error("SevenRooms update error details:", error.response || error);
    },
  });
};
